"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SimpleFormCheckBoxFromOptions", {
  enumerable: true,
  get: function get() {
    return _FormComponents.SimpleFormCheckBoxFromOptions;
  }
});
Object.defineProperty(exports, "SimpleFormCheckbox", {
  enumerable: true,
  get: function get() {
    return _FormComponents.SimpleFormCheckbox;
  }
});
Object.defineProperty(exports, "SimpleFormCheckboxYN", {
  enumerable: true,
  get: function get() {
    return _FormComponents.SimpleFormCheckboxYN;
  }
});
Object.defineProperty(exports, "SimpleFormDatePicker", {
  enumerable: true,
  get: function get() {
    return _FormComponents.SimpleFormDatePicker;
  }
});
Object.defineProperty(exports, "SimpleFormDateRangePicker", {
  enumerable: true,
  get: function get() {
    return _FormComponents.SimpleFormDateRangePicker;
  }
});
Object.defineProperty(exports, "SimpleFormDropdown", {
  enumerable: true,
  get: function get() {
    return _FormComponents.SimpleFormDropdown;
  }
});
Object.defineProperty(exports, "SimpleFormFieldArray", {
  enumerable: true,
  get: function get() {
    return _FormComponents.SimpleFormFieldArray;
  }
});
exports["default"] = void 0;
Object.defineProperty(exports, "formCheckBoxYN", {
  enumerable: true,
  get: function get() {
    return _FormComponents.formCheckBoxYN;
  }
});
Object.defineProperty(exports, "formHeader", {
  enumerable: true,
  get: function get() {
    return _FormComponents.formHeader;
  }
});
Object.defineProperty(exports, "formInput", {
  enumerable: true,
  get: function get() {
    return _FormComponents.formInput;
  }
});
Object.defineProperty(exports, "formLabel", {
  enumerable: true,
  get: function get() {
    return _FormComponents.formLabel;
  }
});
var _Simpleform = require("./Simpleform");
var _FormComponents = require("./FormComponents");
var _default = exports["default"] = _Simpleform.SimpleForm;